export const contractsDetailsStyles = {
  items: {
    borderBottom: 'solid 1px rgba(151, 151, 151, 0.6)',
    borderRight: 'solid 1px rgba(151, 151, 151, 0.6)',
    padding: '40px 40px',
  },
  sectionContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '2em',
  },
  itemContainer: {
    display: 'flex',
    alignItems: 'start',
    flexDirection: 'column',
    gap: '0.5em',
    width: '100%',
  },
  sectionTitle: {
    color: '#004165',
    marginBottom: '0.75em',
    fontWeight: 600,
  },
  sectionTitleAlt: {
    color: '#004165',
    marginTop: '0.75em',
  },
  item: {
    display: 'flex',
    gap: '0.75em',
    alignItems: 'flex-start',
    width: '100%',
    flexWrap: 'wrap',
    minHeight: '24px',
  },
  itemLabel: {
    color: '#333333',
    minWidth: '140px',
    flex: '0 0 auto',
  },
  itemValue: {
    fontWeight: 'bold',
    color: '#333333',
    flex: '1 1 auto',
    wordBreak: 'break-word',
  },
  barChartIcon: {
    width: 64,
    height: 64,
    color: '#004165',
  },
  buildIcon: {
    width: 50,
    height: 64,
    color: '#004165',
  },
}
